import { render, staticRenderFns } from "./candidate-wizard-assessment.vue?vue&type=template&id=5886f2c8&"
import script from "./candidate-wizard-assessment.vue?vue&type=script&lang=js&"
export * from "./candidate-wizard-assessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports